import http from "../utils/AxiosRequest";
import httpForm from "../utils/AxiosFormRequest";

class IndexService {
  addAdmin(data) {
    return httpForm.post("/addadmin", data);
  }

  getAdmins() {
    return http.get("/getadmins");
  }

  deleteAdmin(id, data) {
    return httpForm.delete(`/deleteadmin/?userId=${id}`, data);
  }

  login(data) {
    return http.post("/login", data);
  }

  getLinks() {
    return http.get("/getlink");
  }
  addLink(data) {
    return httpForm.post("/addlink", data);
  }

  editLink(id, data) {
    return httpForm.put(`/editlink/?linkId=${id}`, data);
  }

  deleteLink(id, data) {
    return httpForm.delete(`/deletelink/?linkId=${id}`, data);
  }
  getTeam() {
    return http.get("/getteam");
  }
  addTeam(data) {
    return httpForm.post("/addteam", data);
  }

  editTeam(id, data) {
    return httpForm.put(`/editteam/?teamId=${id}`, data);
  }

  deleteTeam(id, role) {
    return httpForm.delete(`/deleteteam/?teamId=${id}&role=${role}`);
  }

  getCategory() {
    return http.get("/getcategory");
  }
  addCategory(data) {
    return httpForm.post("/addcategory", data);
  }
  editCategory(id, data) {
    return httpForm.put(`/editcategory/?categoryId=${id}`, data);
  }
  getProject() {
    return http.get("/getproject");
  }
  addProject(data, categoryId) {
    return httpForm.post(`/addproject/?categoryId=${categoryId}`, data);
  }
  editProject(id, data) {
    return httpForm.put(`/editproject/?projectId=${id}`, data);
  }

  deleteProject(id, role, categoryId) {
    return httpForm.delete(`/deleteproject/?projectId=${id}&role=${role}&categoryId=${categoryId}`);
  }
  moveProject(id, role, previousCategoryId,currentCategoryId) {
    return httpForm.put(
      `/moveproject/?projectId=${id}&role=${role}&precategoryId=${previousCategoryId}&curcategoryId=${currentCategoryId}`
    );
  }
}

export default new IndexService();
